export default {
  id: null,
  color: '',
  contactEmail: '',
  contactName: '',
  contactPhoneNumber: '',
  lastSavedDate: '',
  lastSavedTime: '',
  nonWarClaimFlagCode: 'EnumYesNoTranslated2',
  nonWarClaimFlagValue: 'No',
  notes: '',
  poNumber: '',
  selectedDamagedOccurred: '',
  selectedRequestedAction: '',
  isWarrantyRepar: false,

  claimLines: [
    {
      id: '1',
      productType: 'Bikes',
      qty: null,
      selectedDamagedOccurred: 'enumDamageOccurredAfterPurchase',
      selectedRequestedAction: 'enumRequestedActionReplace',
      warrantyDamageImage: {name: null, url: null, encodedImage: null},
      warrantyPurchaseProofImage: {name: null, url: null, encodedImage: null},
      warrantySerialNumberImage: {name: null, url: null, encodedImage: null},
      warrantyClaimIssueUfoCode: '',
      warrantyLineNumber: '',
      warrantyOptionalAttachments: [],
      serialNumberImage: {name: null, url: null, encodedImage: null},
      damageMethod: {code: null},
      purchasedDate: '',
      purchaseDateDisplay: '',
      serialNumber: '',
      status: '',
      size: '',
      sku: '',
      modelYear: '',
      modelName: '',
    },
  ],
};
